import api from "./apiConfig";

// Obtener todos los registros
export const GET_ALL_DOES_NO_APPLY = async () => {
    try {
        const response = await api.get("/doesNoApply");
        return response.data;
    } catch (error) {
        console.error("Error al obtener registros DoesNoApply:", error);
        throw error;
    }
};

// Obtener registros por clientId
export const GET_DOES_NO_APPLY_BY_CLIENT = async (clientId) => {
    try {
        const response = await api.get(`/doesNoApply/client/${clientId}`);
        return response.data;
    } catch (error) {
        console.error("Error al obtener registros por cliente:", error);
        throw error;
    }
};

// Crear registro
export const CREATE_DOES_NO_APPLY = async (data) => {
    try {
        const response = await api.post("/doesNoApply", data);
        return response.data;
    } catch (error) {
        console.error("Error al crear registro DoesNoApply:", error);
        throw error;
    }
};

// Actualizar registro por id
export const UPDATE_DOES_NO_APPLY = async (id, data) => {
    try {
        const response = await api.put(`/doesNoApply/${id}`, data);
        return response.data;
    } catch (error) {
        console.error("Error al actualizar registro DoesNoApply:", error);
        throw error;
    }
};